import config from '../config'

export const buildDocumentContentUrl = (airportId, id, { download } = {}) =>
  `${config.baseUrl}/${airportId}/Documents/${id}/content${download ? '?download=true' : ''}`

// Saves an already-fetched blob to the user's device as a file, e.g. after fetching document content for download.
export const triggerBrowserDownload = (blob, name) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const parseFileExtension = fileName => fileName.split('?')[0].split('.').pop().trim()

export const imageExtensions = ['png', 'jpg', 'jpeg', 'gif']

export const isImage = fileName => imageExtensions.indexOf(parseFileExtension(fileName)) !== -1
